module.exports = __webpack_public_path__ + "img/setting.ed20af52.png";